import { render } from "./ImageButtonWithTextBelow.vue?vue&type=template&id=661d8f84&scoped=true"
import script from "./ImageButtonWithTextBelow.vue?vue&type=script&lang=js"
export * from "./ImageButtonWithTextBelow.vue?vue&type=script&lang=js"

import "./ImageButtonWithTextBelow.vue?vue&type=style&index=0&id=661d8f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661d8f84"]])

export default __exports__